import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, Stethoscope, HeartPulse, MessageCircle, ArrowLeft, Sparkles, CheckCircle2, Clock, Shield, Star, FileText, Download } from 'lucide-react';
import MetaTags from '@/components/MetaTags';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
const ServicesLanding = () => {
    const [showContent, setShowContent] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setShowContent(true), 300);
        return () => clearTimeout(timer);
    }, []);
    const handleWhatsAppClick = () => {
        window.open('https://wa.me/09356033011', '_blank');
    };
    const handleLabResultClick = () => {
        window.open('http://93.114.111.53:8086/Login', '_blank');
    };
    return (<div className="min-h-[100dvh] overflow-hidden bg-gradient-to-br from-blue-50 via-white to-cyan-50 relative">
      <MetaTags title="خدمات نمونه‌گیری در محل و چکاپ | آزمایشگاه سلامت" description="درخواست نمونه‌گیری در منزل و چکاپ آنلاین از آزمایشگاه سلامت. خدمات حرفه‌ای با کادر مجرب" keywords="نمونه گیری در محل, چکاپ آنلاین, آزمایشگاه سلامت, درخواست چکاپ" path="/services-landing"/>
      
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        
        <div className="absolute top-10 left-5 w-56 h-56 bg-blue-300 rounded-full mix-blend-multiply filter blur-2xl opacity-25 animate-blob"></div>
        <div className="absolute top-20 right-5 w-56 h-56 bg-cyan-300 rounded-full mix-blend-multiply filter blur-2xl opacity-25 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-1/2 w-56 h-56 bg-indigo-300 rounded-full mix-blend-multiply filter blur-2xl opacity-25 animate-blob animation-delay-4000"></div>
        <div className="absolute top-1/2 right-1/4 w-40 h-40 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-3000"></div>
      </div>

      
      <div className="min-h-[100dvh] flex flex-col relative z-10">
        
        <div className="p-4 pt-6 pb-2">
          <div className={`transition-all duration-700 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center shadow-lg">
                <Stethoscope className="w-6 h-6 text-white"/>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-800">آزمایشگاه سلامت</h1>
                <p className="text-xs text-gray-600">خدمات حرفه‌ای در منزل شما</p>
              </div>
            </div>
          </div>
        </div>

        
        <div className="px-4 mb-6">
          <div className={`transition-all duration-700 delay-200 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 text-white p-8 md:p-10 shadow-2xl">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-white/10 rounded-full blur-3xl animate-pulse animation-delay-2000"></div>
              <div className="absolute top-1/2 right-1/4 w-32 h-32 bg-white/5 rounded-full blur-2xl"></div>
              <div className="relative z-10">
                <div className="flex items-center gap-2 mb-4">
                  <Sparkles className="w-6 h-6 text-yellow-300 animate-pulse"/>
                  <span className="text-sm font-bold text-yellow-100 bg-yellow-400/20 px-3 py-1 rounded-full">خدمات ویژه</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-extrabold mb-4 leading-tight">
                  سلامت شما، اولویت ماست
                </h2>
                <p className="text-blue-50 text-sm md:text-base leading-relaxed max-w-md">
                  با خدمات نمونه‌گیری در محل، چکاپ آنلاین و دریافت جواب آزمایش، بدون نیاز به مراجعه حضوری، سلامت خود را بررسی کنید
                </p>
              </div>
            </div>
          </div>
        </div>

        
        <div className="px-4 space-y-4 flex-1 pb-6">
          
          <div className={`transition-all duration-700 delay-300 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <Card className="overflow-hidden border-2 border-blue-100 bg-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="p-6">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0 transform hover:scale-110 transition-transform">
                    <Home className="w-8 h-8 text-white"/>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">نمونه‌گیری در محل</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      بدون نیاز به مراجعه به آزمایشگاه، در منزل یا محل کارتان نمونه‌گیری انجام دهید
                    </p>
                  </div>
                </div>
                
                <div className="space-y-2.5 mb-5 bg-blue-50 rounded-xl p-3">
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-blue-600 flex-shrink-0"/>
                    <span>کادر مجرب و تجهیزات استریل</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-blue-600 flex-shrink-0"/>
                    <span>خدمات با بیمه تکمیلی رایگان</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-blue-600 flex-shrink-0"/>
                    <span>درخواست آنلاین و سریع</span>
                  </div>
                </div>

                <Link to="/sample-at-home" className="block">
                  <Button className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white rounded-xl h-12 text-base font-semibold shadow-lg hover:shadow-xl transition-all">
                    درخواست نمونه‌گیری در محل
                    <ArrowLeft className="w-4 h-4 mr-2"/>
                  </Button>
                </Link>
              </div>
            </Card>
          </div>

          
          <div className={`transition-all duration-700 delay-400 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <Card className="overflow-hidden border-2 border-emerald-100 bg-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="p-6">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0 transform hover:scale-110 transition-transform">
                    <HeartPulse className="w-8 h-8 text-white"/>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">درخواست چکاپ آنلاین</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      از بین پنل‌های آماده چکاپ انتخاب کنید و به‌صورت آنلاین رزرو نمایید
                    </p>
                  </div>
                </div>
                
                <div className="space-y-2.5 mb-5 bg-emerald-50 rounded-xl p-3">
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-emerald-600 flex-shrink-0"/>
                    <span>پنل‌های متنوع برای همه سنین</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-emerald-600 flex-shrink-0"/>
                    <span>چکاپ عمومی و تخصصی</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-emerald-600 flex-shrink-0"/>
                    <span>رزرو سریع و آسان</span>
                  </div>
                </div>

                <Link to="/checkups/request" className="block">
                  <Button className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white rounded-xl h-12 text-base font-semibold shadow-lg hover:shadow-xl transition-all">
                    مشاهده پنل‌های چکاپ
                    <ArrowLeft className="w-4 h-4 mr-2"/>
                  </Button>
                </Link>
              </div>
            </Card>
          </div>

          
          <div className={`transition-all duration-700 delay-450 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <Card className="overflow-hidden border-2 border-purple-100 bg-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="p-6">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0 transform hover:scale-110 transition-transform">
                    <FileText className="w-8 h-8 text-white"/>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">دریافت جواب آزمایش</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      جواب آزمایش خود را به‌صورت آنلاین و بدون نیاز به مراجعه حضوری دریافت کنید
                    </p>
                  </div>
                </div>
                
                <div className="space-y-2.5 mb-5 bg-purple-50 rounded-xl p-3">
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-purple-600 flex-shrink-0"/>
                    <span>دسترسی سریع و آسان</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-purple-600 flex-shrink-0"/>
                    <span>امکان دانلود و چاپ</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-sm text-gray-700">
                    <CheckCircle2 className="w-4 h-4 text-purple-600 flex-shrink-0"/>
                    <span>اطلاعات کامل و دقیق</span>
                  </div>
                </div>

                <Button onClick={handleLabResultClick} className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-xl h-12 text-base font-semibold shadow-lg hover:shadow-xl transition-all">
                  دریافت جواب آزمایش
                  <Download className="w-4 h-4 mr-2"/>
                </Button>
              </div>
            </Card>
          </div>

          
          <div className={`transition-all duration-700 delay-550 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <Card className="overflow-hidden border-2 border-green-200 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform">
                    <MessageCircle className="w-7 h-7 text-white"/>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">سوالی دارید؟</h3>
                    <p className="text-sm text-gray-600">از طریق واتساپ با ما در ارتباط باشید</p>
                  </div>
                </div>
                
                <Button onClick={handleWhatsAppClick} className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl h-12 text-base font-semibold shadow-lg hover:shadow-xl transition-all">
                  ارتباط با ما در واتساپ
                  <MessageCircle className="w-5 h-5 mr-2"/>
                </Button>
                <p className="text-center text-xs text-gray-600 mt-3 font-medium">شماره: 09356033011</p>
              </div>
            </Card>
          </div>

          
          <div className={`grid grid-cols-3 gap-3 mt-6 transition-all duration-700 delay-650 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 text-center border-2 border-blue-100 shadow-md hover:shadow-lg hover:border-blue-200 transition-all">
              <Clock className="w-6 h-6 text-blue-600 mx-auto mb-2"/>
              <p className="text-xs text-gray-700 font-semibold">سریع و آسان</p>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 text-center border-2 border-emerald-100 shadow-md hover:shadow-lg hover:border-emerald-200 transition-all">
              <Shield className="w-6 h-6 text-emerald-600 mx-auto mb-2"/>
              <p className="text-xs text-gray-700 font-semibold">مطمئن و معتبر</p>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 text-center border-2 border-purple-100 shadow-md hover:shadow-lg hover:border-purple-200 transition-all">
              <Star className="w-6 h-6 text-purple-600 mx-auto mb-2"/>
              <p className="text-xs text-gray-700 font-semibold">کیفیت بالا</p>
            </div>
          </div>
        </div>

        
        <div className={`px-4 pb-6 pt-2 transition-all duration-700 delay-700 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-center">
            <p className="text-xs text-gray-500 mb-1">آزمایشگاه‌های سلامت و شکوه</p>
            <p className="text-sm font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
              salamatlab.com
            </p>
          </div>
        </div>
      </div>

      
      <style>{`
        @keyframes blob {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>);
};
export default ServicesLanding;
